import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import Accueil from "./Components/Accueil"
import Kinesitherapeute from "./Components/Kinesitherapeute"
import Rdv from "./Components/Rdv"
import Acces from "./Components/Acces"
import Faq from "./Components/faq"

export default function App() {
  const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'fr');

  const switchLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem('lang', newLang);
  };

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Redirect to="/accueil" />
        </Route>
        <Route exact path="/accueil" render={(props) => <Accueil {...props} lang={lang} switchLang={switchLang}/> }/>
        <Route exact path="/kinesitherapeute" render={(props) => <Kinesitherapeute {...props} lang={lang} switchLang={switchLang}/> }/>
        <Route exact path="/rendez-vous" render={(props) => <Rdv {...props} lang={lang} switchLang={switchLang}/> }/>
        <Route exact path="/acces" render={(props) => <Acces {...props} lang={lang} switchLang={switchLang}/> }/>
        <Route exact path="/faq" render={(props) => <Faq {...props} lang={lang} switchLang={switchLang}/> }/>
        {/* Redirect old Dutch URLs to their French equivalents */}
        <Route exact path="/home"><Redirect to="/accueil" /></Route>
        <Route exact path="/therapeut"><Redirect to="/kinesitherapeute" /></Route>
        <Route exact path="/contact"><Redirect to="/rendez-vous" /></Route>
        <Route exact path="/bereikbaarheid"><Redirect to="/acces" /></Route>
        <Route exact path="/veelgestelde-vragen"><Redirect to="/faq" /></Route>
      </Switch>
    </Router>
  );
}
